import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "loader-container" }


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingPage',
  setup(__props) {

// Loading page component

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("p", { id: "loadingText" }, "Loading", -1)
  ]))]))
}
}

})